export default __webpack_public_path__ + "static/media/brightcove.d988953e.svg";